export enum StatusContractEnum {
    waitingForDocsProvider = "waitingForDocsProvider",
    waitingForDocsCustomer = "waitingForDocsCustomer",
    waitingForFinanceProvider = "waitingForFinanceProvider",
    waitingForFinanceCustomer = "waitingForFinanceCustomer",
    waitingForAcceptFinanceProvider = "waitingForAcceptFinanceProvider",
    waitingForAcceptDocsAdmin = "waitingForAcceptDocsAdmin",
    adminRejectedDocsCustomer = "adminRejectedDocsCustomer",
    adminRejectedDocsProvider = "adminRejectedDocsProvider",
    adminRejectedDocsBoth = "adminRejectedDocsBoth",
    waitingForContract = "waitingForContract",
    customerRequestforRevision = "customerRequestforRevision",
    providerRequestforRevision = "providerRequestforRevision",
    bothRequestForRevision = "bothRequestForRevision",
    customerRejectedContract = "customerRejectedContract",
    providerRejectedContract = "providerRejectedContract",
    waitingForContractUploadBoth = "waitingForContractUploadBoth",
    waitingForContractUploadCustomer = "waitingForContractUploadCustomer",
    waitingForContractUploadProvider = "waitingForContractUploadProvider",
    waitingForFinalApproveAdmin = "waitingForFinalApproveAdmin",
    waitingForAdminApproveProviderContract = "waitingForAdminApproveProviderContract",
    adminRejectedContractCustomer = "adminRejectedContractCustomer",
    adminRejectedContractProvider = "adminRejectedContractProvider",
    adminRejectedContractBoth = "adminRejectedContractBoth",
    waitingForSignatures = "waitingForSignatures",
    waitingForCustomerSignature = "waitingForCustomerSignature",
    waitingForProviderSignature = "waitingForProviderSignature",
    contractCompletion = "contractCompletion",
    contractCanceledByAdmin = "contractCanceledByAdmin",
    contractExpired = "contractExpired",
}
